const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8356 4.10426L11.3394 4.14231C6.19942 4.51897 2.13086 8.79978 2.13086 14.0366C2.13086 19.5214 6.56983 23.9673 12.0555 23.9673C17.293 23.9673 21.5684 19.8895 21.9475 14.7495L21.9802 13.2563H12.8356V4.10426ZM20.4703 14.7784C20.0981 19.3446 16.4725 22.4999 12.0487 22.4999C7.37664 22.4999 3.58812 18.7099 3.58812 14.0381C3.58812 9.61433 6.7473 5.98633 11.3135 5.61355V14.7787L20.4703 14.7784ZM14.1299 2.10059V11.9622H23.9844C23.9844 6.63469 19.4572 2.10059 14.1299 2.10059ZM15.652 3.6827C16.413 3.79151 16.8278 3.97255 17.4214 4.22375C18.4304 4.65005 19.3011 5.26096 20.0797 6.03953C20.8583 6.81811 21.4519 7.65732 21.8788 8.66659C22.13 9.26025 22.2926 9.67882 22.4023 10.4399H15.652V3.6827Z",
    fill: "#272636",
    stroke: "black",
    style: {
      fill: "#272636",
      fill: "color(display-p3 0.1529 0.1490 0.2118)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.533333
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalysis);
export default __webpack_public_path__ + "static/media/icon-analysis.13f6634e15a0cf410986ffb95524560d.svg";
export { ForwardRef as ReactComponent };